const STATUS_CONFIG = {
  // Certificate statuses
  issued: { bg: 'rgba(59,130,246,0.1)', color: '#60a5fa', label: 'Issued' },
  shipped: { bg: 'rgba(245,158,11,0.1)', color: '#f59e0b', label: 'Shipped' },
  delivered: { bg: 'rgba(168,85,247,0.1)', color: '#a855f7', label: 'Delivered' },
  activated: { bg: 'rgba(6,182,212,0.12)', color: '#06b6d4', label: 'Activated' },
  live: { bg: 'rgba(16,185,129,0.1)', color: '#10b981', label: 'Live' },
  expired: { bg: 'rgba(100,116,139,0.1)', color: '#64748b', label: 'Expired' },
  revoked: { bg: 'rgba(239,68,68,0.1)', color: '#ef4444', label: 'Revoked' },

  // Appliance statuses
  registered: { bg: 'rgba(100,116,139,0.1)', color: '#475569', label: 'Registered' },
  pending_activation: { bg: 'rgba(245,158,11,0.1)', color: '#f59e0b', label: 'Pending' },
  online: { bg: 'rgba(16,185,129,0.1)', color: '#10b981', label: 'Online' },
  offline: { bg: 'rgba(239,68,68,0.1)', color: '#ef4444', label: 'Offline' },
  decommissioned: { bg: 'rgba(100,116,139,0.1)', color: '#64748b', label: 'Decommissioned' },

  // License statuses
  active: { bg: 'rgba(6,182,212,0.12)', color: '#06b6d4', label: 'Active' },
  pending: { bg: 'rgba(245,158,11,0.1)', color: '#f59e0b', label: 'Pending' },
  suspended: { bg: 'rgba(245,158,11,0.1)', color: '#f59e0b', label: 'Suspended' },

  // Ticket statuses
  open: { bg: 'rgba(59,130,246,0.1)', color: '#60a5fa', label: 'Open' },
  in_progress: { bg: 'rgba(6,182,212,0.12)', color: '#06b6d4', label: 'In Progress' },
  waiting: { bg: 'rgba(245,158,11,0.1)', color: '#f59e0b', label: 'Waiting' },
  resolved: { bg: 'rgba(16,185,129,0.1)', color: '#10b981', label: 'Resolved' },
  closed: { bg: 'rgba(100,116,139,0.1)', color: '#64748b', label: 'Closed' },

  // Payment
  confirmed: { bg: 'rgba(16,185,129,0.1)', color: '#10b981', label: 'Confirmed' },
  failed: { bg: 'rgba(239,68,68,0.1)', color: '#ef4444', label: 'Failed' },
  pending_payment: { bg: 'rgba(245,158,11,0.1)', color: '#f59e0b', label: 'Pending Payment' },
};

export default function StatusBadge({ status, showDot = true }) {
  const config = STATUS_CONFIG[status] || { bg: 'rgba(100,116,139,0.1)', color: '#475569', label: status };
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-[2px] rounded-xl text-[10px] font-semibold"
      style={{ background: config.bg, color: config.color }}
    >
      {showDot && (
        <span className="w-[5px] h-[5px] rounded-full" style={{ background: 'currentColor' }} />
      )}
      {config.label}
    </span>
  );
}
